/**
 * governance/utils/severity.ts
 * Canonical severity types, ordering, helpers, and display utilities.
 */

/** Canonical severity type — 3 levels only, no 'error' */
export type SeverityLevel = 'critical' | 'warning' | 'info';
export const SEVERITY_ORDER: Record<SeverityLevel, number> = {
  critical: 0,
  warning: 1,
  info: 2
};
export function compareSeverity(a: SeverityLevel, b: SeverityLevel): number {
  return SEVERITY_ORDER[a] - SEVERITY_ORDER[b];
}
export function isBlockingSeverity(level: SeverityLevel): boolean {
  return level === 'critical';
}
export function severityLabel(level: SeverityLevel): string {
  const labels: Record<SeverityLevel, string> = {
    critical: '🔴 Critical',
    warning: '🟡 Warning',
    info: '🔵 Info'
  };
  return labels[level];
}
export function severityColor(level: SeverityLevel): string {
  const colors: Record<SeverityLevel, string> = {
    critical: '#ef4444',
    warning: '#eab308',
    info: '#3b82f6'
  };
  return colors[level];
}

/** Penalty weights per severity — STRENGTHENED */
export const SEVERITY_WEIGHTS: Record<SeverityLevel, number> = {
  critical: 30,
  warning: 12,
  info: 3
};

/** Normalize any legacy severity string to canonical SeverityLevel */
export function normalizeSeverity(raw: string | undefined): SeverityLevel {
  if (raw === 'critical' || raw === 'error' || raw === 'high') return 'critical';
  if (raw === 'warning' || raw === 'medium') return 'warning';
  return 'info';
}